import { errorView } from '@krp/client-runtime'

import type { MutationVm } from './types'

/**
 * Минимум полей результата мутации RTK Query, который нужен vm, — то, что
 * отдаёт хук `useMutation` (или `select` по `fixedCacheKey`). Аргументы
 * мутации сюда не входят: vm их не видит.
 */
export interface MutationResultLike<T> {
  data?: T
  error?: unknown
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}

export const IDLE_MUTATION: MutationResultLike<never> = { isLoading: false, isError: false, isSuccess: false }

/** Состояние команды для экрана: идёт / ошибка сервера дословно с кодом и корреляцией. */
export function mutationView(result: MutationResultLike<unknown>): MutationVm {
  if (result.isError && result.error !== undefined) {
    const error = errorView(result.error)
    return { busy: false, error: { message: error.message, code: error.code, correlationId: error.correlationId } }
  }
  return { busy: result.isLoading, error: null }
}
